(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mr-board-care-story"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateCareSummaries = (excludedSection) => {
      document.querySelectorAll('[data-mr-care-summary]').forEach((summary) => {
        const productId = summary.dataset.mrCareSummary;
        const phases = new Set();
        document.querySelectorAll('[data-mr-care-product]').forEach((story) => {
          if (excludedSection?.contains(story)) return;
          if (story.dataset.mrCareProduct !== productId || !story.querySelector('img[src]')) return;
          phases.add(story.dataset.mrCarePhase);
        });
        const ready = phases.has('wash') && phases.has('dry');
        const full = summary.querySelector('[data-mr-care-full]');
        const concise = summary.querySelector('[data-mr-care-concise]');
        if (full && concise) {
          full.hidden = ready;
          concise.hidden = !ready;
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => updateCareSummaries(), { once: true });
    } else {
      updateCareSummaries();
    }
    document.addEventListener('shopify:product:select', (event) => {
      if (!event.promise || typeof event.promise.then !== 'function') return;
      event.promise.then(
        () => updateCareSummaries(),
        () => updateCareSummaries()
      );
    });
    document.addEventListener('shopify:section:load', () => updateCareSummaries());
    document.addEventListener('shopify:section:unload', (event) => updateCareSummaries(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
